import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_sales_order,
  get_sales_order,
  update_sales_order,
} from "../../../../Controllers/Sales/SO";
import forms from "../../../../Data/Forms/Sales/SO/forms";
import headers from "../../../../Data/Forms/Sales/SO/heders";
import Loadercomponent from "../../../../Componets/Loader";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import SalesOrdertable from "../../../../Data/Forms/Sales/SO/table";
import dayjs from "dayjs";

const SalesForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [header, setHeader] = useState(headers);

  const getFilteredFormOptions = () => {
    const baseForm = forms[0];

    if (id) {
      return [baseForm];
    } else {
      const filteredOptions = baseForm.options.filter(
        (option) => option.name !== "Status",
      );

      return [
        {
          ...baseForm,
          options: filteredOptions,
        },
      ];
    }
  };

  const [values, setValues] = useState(getFilteredFormOptions());
  const [note, setNote] = useState();

  const focus = useRef([]);

  const [details, setDetails] = useState([
    {
      id: "",
      description: null,
      name: "",
      unit: "",
      unit_name: "",
      unit_details_options: null,
      conversion: 0,
      quantity: "",
      sales_order: "",
      sales_order_price: "",
      sales_order_options: null,
      barcode: "",
      price_per_unit: "",
      sale_price: "",
      expiry_date: "",
      total: 0,
      source: "Sales",
    },
  ]);

  const [totals, setTotals] = useState({
    total: "0.000",
  });

  const findFieldIndex = (fieldName) => {
    return values[0].options.findIndex((option) => option.name === fieldName);
  };

  const detailsvalidation = (tabledata) => {
    let params = {};

    if (details?.length > 0) {
      let total = details?.length;
      let count = 0;

      let validated = [];
      details?.map((v, i) => {
        if (count == i) {
          if (!v?.description) {
            document.getElementById(`description${i}`).textContent =
              `Description is required`;
            focus.current[`description${i}`].current.focus();
          } else if (!v?.sale_price) {
            document.getElementById(`sale_price${i}`).textContent =
              `Sale price is required`;
            focus.current[`sale_price${i}`].current.focus();
          } else if (!v?.quantity) {
            document.getElementById(`quantity${i}`).textContent =
              `Quantity is required`;
            focus.current[`quantity${i}`].current.focus();
          } else {
            document.getElementById(`description${i}`).textContent = ``;
            document.getElementById(`sale_price${i}`).textContent = ``;
            document.getElementById(`quantity${i}`).textContent = ``;

            validated?.push(v);
            count++;
          }
        }
      });

      if (count == total) {
        params = {
          status: true,
          data: {
            ...tabledata,
            details: validated,
          },
        };

        return params;
      } else {
        params = {
          status: false,
          data: null,
        };

        return params;
      }
    } else {
      toast?.error("Details not found");
    }
  };

  const totalsvalidation = (tabledata) => {
    let params = {};

    params = {
      status: true,
      data: {
        ...tabledata,
        id: id ? id : "",
        total: totals?.total,
        note: note,
        source: "Sales",
      },
    };
    return params;
  };

  const formdata = async (data) => {
    if (data?.status) {
      const tabledetailsvalidation = detailsvalidation(data?.data);

      if (tabledetailsvalidation?.status) {
        const tabletotalvalidation = totalsvalidation(
          tabledetailsvalidation?.data,
        );

        if (tabletotalvalidation?.status) {
          setButtonLoader(true);

          const payload = {
            ...tabletotalvalidation.data,
          };

          const sales_order = id
            ? await update_sales_order(payload)
            : await create_sales_order(payload);
          if (sales_order?.status) {
            navigate(-1);
            toast?.success(sales_order?.message);
            setButtonLoader(false);
          } else {
            setButtonLoader(false);
            if (sales_order?.status_code == 403) {
              window.location.href = "/unauthorized";
            } else {
              toast?.error(sales_order?.message);
            }
          }
        }
      }
    }
  };

  const handleData = (sales_order) => {
    let customer = sales_order?.customer?._id
      ? sales_order?.customer?._id
      : null;
    let number = sales_order?.number ? sales_order?.number : "";
    let date = sales_order?.date ? sales_order?.date : "";
    let due_date = sales_order?.due_date ? sales_order?.due_date : "";
    let lpo_number = sales_order?.lpo_number ? sales_order?.lpo_number : "";
    let lpo_date = sales_order?.lpo_date ? sales_order?.lpo_date : "";
    let salesman = sales_order?.salesman?._id
      ? sales_order?.salesman?._id
      : null;
    let status = sales_order?.status ? sales_order?.status : 0;

    let salesman_options = sales_order?.salesman?._id
      ? [
          {
            value: sales_order?.salesman?._id,
            label: sales_order?.salesman?.name,
          },
        ]
      : null;

    let customer_option = sales_order?.customer?._id
      ? [
          {
            value: sales_order?.customer?._id,
            label:
              sales_order?.customer?.name && sales_order?.customer?.phone
                ? sales_order?.customer?.name +
                  " (" +
                  sales_order?.customer?.phone +
                  ")"
                : sales_order?.customer?.name
                  ? sales_order?.customer?.name
                  : sales_order?.customer?.phone
                    ? sales_order?.customer?.phone
                    : "",
          },
        ]
      : null;

    const currentValues = [...values];

    const customerIndex = findFieldIndex("Customer");
    const numberIndex = findFieldIndex("Number");
    const dateIndex = findFieldIndex("Date");
    const dueDateIndex = findFieldIndex("Due Date");
    const lpoNumberIndex = findFieldIndex("LPO Number");
    const lpoDateIndex = findFieldIndex("LPO Date");
    const salesmanIndex = findFieldIndex("Salesman");
    const statusIndex = findFieldIndex("Status");

    if (customerIndex !== -1) {
      currentValues[0].options[customerIndex].form.value = customer;
      currentValues[0].options[customerIndex].form.options = customer_option;
    }

    if (numberIndex !== -1) {
      currentValues[0].options[numberIndex].form.value = number;
    }

    if (dateIndex !== -1) {
      currentValues[0].options[dateIndex].form.value = date;
    }

    if (dueDateIndex !== -1) {
      currentValues[0].options[dueDateIndex].form.value = due_date;
    }

    if (lpoNumberIndex !== -1) {
      currentValues[0].options[lpoNumberIndex].form.value = lpo_number;
    }

    if (lpoDateIndex !== -1) {
      currentValues[0].options[lpoDateIndex].form.value = lpo_date;
    }

    if (salesmanIndex !== -1) {
      currentValues[0].options[salesmanIndex].form.value = salesman;
      currentValues[0].options[salesmanIndex].form.options =
        salesman_options;
    }

    if (statusIndex !== -1) {
      currentValues[0].options[statusIndex].form.value = status;
    }

    let data = [];

    sales_order?.details?.map((value, index) => {

      data?.push({
        id: value?._id,
        description: value?.description?._id,
        batch: value?.description?.number,
        expiry_date: value?.description?.expiry_date,
        category: value?.description?.product?.category
          ? value?.description?.product?.category
          : null,
        name: value?.name,
        unit: value?.unit,
        unit_name: value?.unit_name,
        unit_details_options: value?.unit_details_options,
        conversion: value?.conversion,
        sale_price: value?.sale_price,
        quantity: value?.quantity,
        barcode: value?.barcode,
        price_per_unit: value?.price_per_unit,
        sale_price: value?.sale_price,
        retail_price: value?.description?.product?.sale_price
          ? value?.description?.product?.sale_price
          : value?.sale_price
            ? value?.sale_price
            : 0,
        expiry_date: value?.expiry_date,
        total: value?.total,
      });
    });

    totals.total = sales_order?.total;

    setValues(currentValues);
    setDetails([...data]);
    setTotals({ ...totals });
    setNote(sales_order?.note);
    setLoader(false);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const sales_order = await get_sales_order(data);
      if (sales_order?.status) {
        handleData(sales_order?.data);
      } else {
        toast?.error(sales_order?.message);
      }
    } else {
      const filteredValues = getFilteredFormOptions();

      const dateIndex = findFieldIndex("Date");
      const dueDateIndex = findFieldIndex("Due Date");

      if (dateIndex !== -1) {
        filteredValues[0].options[dateIndex].form.value = new Date();
      }

      if (dueDateIndex !== -1) {
        // filteredValues[0].options[dueDateIndex].form.value = new Date();
      }

      setValues(filteredValues);

      setTotals({ ...totals });
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        >
          <Bodycomponent>
            <Titlecomponent index={1} title={"Items"} />
            <Formdata>
              <Headercomponent index={0} name={"Details"} required={true} />
              <SalesOrdertable
                details={details}
                setDetails={setDetails}
                totals={totals}
                setTotals={setTotals}
                ref={focus}
                note={note}
                setNote={setNote}
              />
            </Formdata>
          </Bodycomponent>
        </Forms>
      </Loadercomponent>
    </Header>
  );
};

export default SalesForm;